import {DocumentRoutes} from './documents'
import {ChangeDependentRoutes} from './procedures/changeDependents'
import {RouteParams} from 'types/routes'

export const mypageRoutes: RouteParams[] = [...DocumentRoutes, ...ChangeDependentRoutes]
